export const SET_CAD_FORM_DATA = 'SET_CAD_FORM_DATA';
export const SEND_CAD_FORM_NOTIFICATION = 'SEND_CAD_FORM_NOTIFICATION';
export const SET_CAD_FORM_BEGIN_LOADING = 'SET_CAD_FORM_BEGIN_LOADING';
export const SET_CAD_FORM_STOP_LOADING = 'SET_CAD_FORM_STOP_LOADING';
export const CREATE_CUSTOM_ATTRIBUTES_DEFINITION = 'CREATE_CUSTOM_ATTRIBUTES_DEFINITION';
export const GET_CUSTOM_ATTRIBUTE_DEFINITION_FORM_DATA =
	'GET_CUSTOM_ATTRIBUTE_DEFINITION_FORM_DATA';
export const UPDATE_CUSTOM_ATTRIBUTES_DEFINITION = 'UPDATE_CUSTOM_ATTRIBUTES_DEFINITION';

export const STATE_KEY = 'cad-form';
